import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { defaultConfig } from "../../config";
import { ChatSvg, EditnewSvg, EditSvg, StarSvg } from "../../svgFile";
import { usePage } from "../../PageContext";

const ProfileSidebar = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");
  const user = JSON.parse(localStorage.getItem("userData"));
  const { setProfilePhoto } = usePage();
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    setProfilePhoto(null);
    const offcanvasEl = document.getElementById("mainMenu");

    if (offcanvasEl) {
      let offcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
      if (!offcanvas) offcanvas = new window.bootstrap.Offcanvas(offcanvasEl);
      offcanvas.hide();
    }
  };
  const handleProfileClick = () => {
    if (token) {
      navigate("/myprofile");
    }
  };

  const handleNavAndClose = (path) => {
    const offcanvasEl = document.getElementById("mainMenu");
    if (offcanvasEl) {
      let offcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
      if (!offcanvas) offcanvas = new window.bootstrap.Offcanvas(offcanvasEl);
      offcanvas.hide();
    }
    navigate(path);
  };
  const { profilePhoto } = usePage();
  return (
    <aside className="profile-sidebar d-none d-xl-block">
      <div className="profile-card">
        <div className="sidebar-profile mx-auto text-center mt-0 mb-4 desktop-sidebar-profile">
          <div
            className="s-pimg position-relative"
            onClick={handleProfileClick}
          >
            <img
              src={
                profilePhoto
                  ? defaultConfig.Userimage + profilePhoto
                  : "/image/profile.png"
              }
              alt=""
            />
            {token && (
              <label className="my-edit" style={{ cursor: "pointer" }}>
                <EditSvg />
              </label>
            )}
          </div>
          <div className="side-p-content">
            <p className="mb-2">Welcome</p>
            {token ? (
              <h3>{user?.full_name}</h3>
            ) : (
              <h3>
                <span>
                  <Link
                    to="/signin"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAndClose("/signin");
                    }}
                  >
                    Login
                  </Link>
                </span>
                /
                <span>
                  <Link
                    to="/signup"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAndClose("/signup");
                    }}
                  >
                    SignUp
                  </Link>
                </span>
              </h3>
            )}

            <div className="d-flex align-items-center gap-2 justify-content-center mt-3">
              {token && user?.role === "Player" && (
                <>
                  <button
                    className="pr-icon"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAndClose(token ? "/profile/skill" : "/signin");
                    }}
                  >
                    <StarSvg />
                  </button>
                  <button
                    className="pr-icon"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAndClose(token ? "/notes" : "/signin");
                    }}
                  >
                    <EditnewSvg />
                  </button>
                </>
              )}
              {token && (
                <button
                  className="pr-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/chats" : "/signin");
                  }}
                >
                  <ChatSvg />
                </button>
              )}
            </div>
          </div>
        </div>

        <ul className="profile-menu">
          {token && user?.role === "Coach" && (
            <li>
              <Link
                className="nav-link"
                to={token ? "/player-invitation" : "/signin"}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavAndClose(token ? "/player-invitation" : "/signin");
                }}
              >
                <span className="me-3">
                  <img src="/image/invitation.png" alt="" />
                </span>
                Player Invitation
              </Link>
            </li>
          )}

          {(!token || user?.role === "Player") && (
            <>
              <li>
                <Link
                  to={token ? "/personal-training" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/personal-training" : "/signin");
                  }}
                >
                  <span className=" me-3">
                    <img src="/image/training.svg" alt="" />
                  </span>
                  Personal Training Session
                </Link>
              </li>
              <li>
                <Link
                  to={token ? "/profile/skill" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/profile/skill" : "/signin");
                  }}
                >
                  <span className=" me-3">
                    <img src="/image/skillsvg.svg" alt="" />
                  </span>
                  My Skills
                </Link>
              </li>
              <li>
                <Link
                  to={token ? "/allocated-training" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(
                      token ? "/allocated-training" : "/signin",
                    );
                  }}
                >
                  <span className=" me-3">
                    <img src="/image/allocated.svg" alt="" />
                  </span>
                  Coaches Training
                </Link>
              </li>

              <li>
                <Link
                  className="nav-link"
                  to={token ? "/invitation" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/invitation" : "/signin");
                  }}
                >
                  <span className="me-3">
                    <img src="/image/invitation.png" alt="" />
                  </span>
                  Coach Invitation
                </Link>
              </li>
              {/* <li>
                <Link
                  className="nav-link"
                  to={token ? "/payment-history" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/payment-history" : "/signin");
                  }}
                >
                  <span className="me-3">
                    <img src="/image/paymenthistory.png" alt="" />
                  </span>
                 Transaction History
                </Link>
              </li> */}
            </>
          )}
          {token && (
            <li>
              <Link to="/signin" onClick={handleLogout}>
                {" "}
                <span className="me-3">
                  <img src="/image/logout.svg" alt="" />
                </span>
                Logout
              </Link>
            </li>
          )}
        </ul>
      </div>
    </aside>
  );
};

export default ProfileSidebar;
